"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHTMLCanvasElement = isHTMLCanvasElement;
function isHTMLCanvasElement(el) {
    return (el === null || el === void 0 ? void 0 : el.getContext) != null && (el === null || el === void 0 ? void 0 : el.toBlob) != null;
}
//# sourceMappingURL=create-canvas-element.js.map